<div>
    <h2>Distribución de activos por categoría</h2>
    <p>Total de Activos: <strong>{{ totalAssets }}</strong></p>

    <div class="chart-container">
        <p-chart width="360px" type="pie" [data]="categoryChartData" [options]="chartOptions"></p-chart>
    </div>
</div>